angular.module('elidb').filter('cleanAddress', function() {
    return function(string) {
    	if(!string) return;
        return string.replace(/, ,/gim,"")
        		.replace(/^(\s+)?,/gim,"");
    };
});